module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "urban-1.b13734e6.jpeg";